module.exports = __webpack_public_path__ + "static/img/IDaaS-icon-3.9104eee4.svg";